<div class="modal-header">
  <h5 class="text-info" id="exampleModalLongTitle">
    {{ fromParent?.data?.title }}
  </h5>
  <button type="button" class="close btn-close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body main-modal">
  <div [innerHTML]="fromParent?.data?.description"></div>
</div>